<template>
  <div class="record">
    <div class="filter-content">
      <div class="time-content">
        <el-col class="line" :span="4">录入时间</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="开始日期" value-format="timestamp" :picker-options="pickerOptionEntryStart"
                          v-model="rev_start" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptionEntryEnd"
                          v-model="rev_end" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <div class="time-content">
        <el-col class="line" :span="4">报告时间</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="开始" value-format="timestamp" v-model="diagnose_start" :picker-options="pickerOptionProjStart"
                          style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptionProjEnd"
                          v-model="diagnose_end" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <el-button type="primary" class="search-btn" @click="searchHandle">搜索</el-button>
      <el-button type="success" class="search-btn export-btn" @click="getDownloadUrl" :disabled="download_dis">批量下载</el-button>
    </div>
    <el-table
      :data="listData"
      v-loading="loading"
      border
      @selection-change="selectHandle"
      header-row-class-name="change-header-style"
      style="width: 100%;margin-top: 20px;min-height: 550px;">
      <el-table-column
					type="selection"
					width="40"
          :selectable="selectInit"
          fixed="left">
			</el-table-column>
      <el-table-column
        type="index"
        :index="indexHandle"
        label="序号"
        width="40"
        fixed="left">
      </el-table-column>
      <el-table-column
        prop="projName"
        width="280"
        label="项目名称"
        fixed="left">
        <template slot="header" slot-scope="scope">
          <span>项目名称</span>
          <el-input @keyup.enter.native="searchHandle" v-model="proj_name_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="csrName"
        label="客户姓名"
        width="140"
      fixed="left">
        <template slot="header" slot-scope="scope">
          <span>客户姓名</span>
          <el-input @keyup.enter.native="searchHandle" v-model="user_name_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="csrGender"
        width="50"
        label="性别">
      </el-table-column>
      <el-table-column
        width="50"
        prop="csrAge"
        label="年龄">
      </el-table-column>
      <el-table-column
        prop="expName"
        label="专家姓名"
        width="120">
      </el-table-column>
      <el-table-column
        prop="curState"
        label="记录状态"
        width="120">
        <template slot="header" slot-scope="scope">
          <span>记录状态</span>
          <el-select popper-class="filter_options cur_state_options ul_cur_state_options" v-model="cur_state_select" placeholder="请选择"
                     @change="searchHandle">
            <el-option
              v-for="item in cur_state_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <p v-if="scope.row.curState == 0" style="padding:4px 8px;background:#5cb85c;color:#fff;text-align: center;border-radius: 4px;">新纪录</p>
          <p v-if="scope.row.curState == 10" style="padding:4px 8px;background:#5bc0de;color:#fff;text-align: center;border-radius: 4px;">发起会诊</p>
          <p v-if="scope.row.curState == 20" style="padding:4px 8px;background:#2E8BFF;color:#fff;text-align: center;border-radius: 4px;">给出诊断</p>
          <p v-if="scope.row.curState == 25" style="padding:4px 8px;background:#f0ad4e;color:#fff;text-align: center;border-radius: 4px;">已经接诊</p>
          <p v-if="scope.row.curState == 30" style="padding:4px 8px;background:#337ab7;color:#fff;text-align: center;border-radius: 4px;">给出建议</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="examineState"
        label="审核状态"
        width="120">
        <template slot="header" slot-scope="scope">
          <span style="text-align: center;">审核状态</span>
          <el-select v-model="examine_state_select" placeholder="请选择" popper-class="filter_options order_state_options"
                     @change="searchHandle">
            <el-option
              v-for="item in examine_state_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.examineState == 0"
               style="padding:4px 8px;background:#f0ad4e;color:#fff;text-align: center;border-radius: 4px;">待审核
          </div>
          <div v-if="scope.row.examineState == 10"
               style="padding:4px 8px;background:#5cb85c;color:#fff;text-align: center;border-radius: 4px;">审核通过
          </div>
          <div v-if="scope.row.examineState == 100"
               style="padding:4px 8px;background:#999999;color:#fff;text-align: center;border-radius: 4px;">废单
          </div>
          <div v-if="scope.row.examineState == 20"
               style="padding:4px 8px;background:#d9534f;color:#fff;text-align: center;border-radius: 4px;">驳回
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="rptLevel"
        width="90"
        label="报告级别">
        <template slot="header" slot-scope="scope">
          <span>报告级别</span>
          <el-select popper-class="filter_options level_options ul_level_options" v-model="rpt_level_select" placeholder="请选择"
                     @change="searchHandle">
            <el-option
              v-for="item in rpt_level_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.rptLevel == 1"
               style="padding:4px 8px;background:#5cb85c;color:#fff;text-align: center;border-radius: 4px;">1级
          </div>
          <div v-if="scope.row.rptLevel == 2"
               style="padding:4px 8px;background:#f0ad4e;color:#fff;text-align: center;border-radius: 4px;">2级
          </div>
          <div v-if="scope.row.rptLevel == 3"
               style="padding:4px 8px;background:#da3530;color:#fff;text-align: center;border-radius: 4px;">3级
          </div>
          <div v-if="scope.row.rptLevel == 0"></div>
        </template>
      </el-table-column>

      <el-table-column
        width="160"
        prop="heartRecvTime"
        label="录入时间">
        <template slot-scope="scope">
          <div v-if="scope.row.heartRecvTime != 0 && scope.row.heartRecvTime != null">
            {{ scope.row.heartRecvTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="csrMobile"
        label="手机号码"
        width="120">
      </el-table-column>
      <el-table-column
        prop="checkCode"
        width="120"
        label="识别码">
      </el-table-column>
      <el-table-column
        prop="devCode"
        label="设备编码"
        width="160">
      </el-table-column>
      <el-table-column
        width="160"
        prop="diagnoseTime"
        label="报告时间">
        <template slot-scope="scope">
          <div v-if="scope.row.diagnoseTime != 0 && scope.row.diagnoseTime != null">
            {{ scope.row.diagnoseTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="examCode"
        label="客户编码"
        width="210">
        <template slot="header" slot-scope="scope">
          <span>客户编码</span>
          <el-input @keyup.enter.native="searchHandle" v-model="exam_code_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        width="170"
        label="操作"
        fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" title="操作记录" icon="el-icon-s-order"
                     @click="showOperationDia(scope.row)"></el-button>
          <el-button type="success" title="缩略图" icon="el-icon-view"
                     @click="showPicHandle(scope.row)"></el-button>
          <el-button type="primary" title="下载报告" icon="el-icon-download"
                     @click="downloadReportHandle(scope.row)" v-if="scope.row.curState == 30"></el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="no-data">
          当前暂无数据
        </div>
      </template>
    </el-table>
    <page-nation :total="page_total" @pageChange="pageChange" :current_page="current_page" :page_sizes="page_sizes"
                 :page_limit="page_limit"></page-nation>

    <el-dialog
      :visible.sync="showPreviewDialog"
      title="预览图像"
      width="840px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding-bottom: 10px;"
      custom-class="line-dialog"
      show-close>
      <div class="dia-load">
        <heart-iframe ref="canvasView" @changeCurPage="changeCurPage" :etc_url="file_name" :file_size="file_size"></heart-iframe>
      </div>
    </el-dialog>

    <operation-record ref="operation_record"></operation-record>

  </div>
</template>

<script>
import PageNation from "./Common/PageNation";
import OperationRecord from "./Common/OperationRecord";
import HeartIframe from "./Common/HeartIframe";
import ApiService from "../service/ApiService";
import pub from "../service/public";

export default {
  name: "RecordList",
  components: {
    PageNation: PageNation,
    OperationRecord:OperationRecord,
    HeartIframe:HeartIframe,
  },
  data(){
    return {
      rev_start: '',  // 录入时间
      rev_end: '',
      pickerOptionEntryStart: {
        disabledDate: time => {
          if (this.rev_end) {
            return time.getTime() > new Date(this.rev_end).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionEntryEnd: {
        disabledDate: time => {
          if (this.rev_start) {
            return time.getTime() < new Date(this.rev_start).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      diagnose_start: '',  // 报告时间
      diagnose_end:'',
      pickerOptionProjStart: {
        disabledDate: time => {
          if (this.diagnose_end) {
            return time.getTime() > new Date(this.diagnose_end).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionProjEnd: {
        disabledDate: time => {
          if (this.diagnose_start) {
            return time.getTime() < new Date(this.diagnose_start).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      listData: [],
      loading: false,
      page_total:0,
      current_page: 1,
      page_sizes: [10, 20, 50, 100],
      page_limit: 10, // 每页多少条
      proj_name_search:'',
      user_name_search:'',
      exam_code_search:'',
      cur_state_select:-1,
      cur_state_options:[
        {value: -1, label: '全部'},
        // {value: 0, label: '新纪录'},
        // {value: 10, label: '发起会诊'},
        // {value: 25, label: '已经接诊'},
        // {value: 30, label: '给出建议'},
      ],
      showPreviewDialog: false,
      file_name: '',
      file_size:0,
      consReportUrl:'',
      timer:null,
      examine_state_options:[
        {value: -1,label: '全部'},
      ],
      examine_state_select:-1,
      // add by xxt 2021-12-07 添加报告级别
      rpt_level_select: -1,
      rpt_level_options:[
        {value: -1, label: '全部'},
        {value: 1, label: '1级'},
        {value: 2, label: '2级'},
        {value: 3, label: '3级'},
      ],
      download_dis:false,
      batch_list:[],
    }
  },
  created() {
    this.initData();
    this.getExamineStateList();
    this.getCurStateList();
  },
  methods:{
    indexHandle(index){
      index = (index + 1) + (this.current_page - 1) * this.page_limit;
      return index
    },

    pageChange(item) {
      this.current_page = item.current_page;
      if(item.type == 'size'){
        this.page_limit = item.page_limit;
      }
      this.initData(); //改变页码，重新渲染页面
    },

    selectInit(row){
      if(row.curState == 30){
        return 1
      }else{
        return 0
      }
    },

    initData(){
      this.loading = true;
      this.listData = [];
      let rev_start = 0;
      let rev_end = 0;
      if(this.rev_start){
        rev_start = this.rev_start/1000;
      }
      if(this.rev_end){
        rev_end = this.rev_end/1000;
      }
      let diagnose_start = 0;
      let diagnose_end = 0;
      if (this.diagnose_start) {
        diagnose_start = this.diagnose_start / 1000;
      }
      if (this.diagnose_end) {
        diagnose_end = this.diagnose_end / 1000;
      }
      let params = {
        page:{
          number: this.current_page - 1,
          limit: this.page_limit
        },
        keyWord: [],
        parms: {
          csrName: this.user_name_search,           //客户姓名
          projName: this.proj_name_search,          // 项目名称
          diagnoseStart:diagnose_start,             // 报告时间
          diagnoseEnd:diagnose_end,                 // 报告时间
          recvStart:rev_start,             // 录入时间
          recvEnd:rev_end,
          curState:this.cur_state_select,
          examCode:this.exam_code_search,
          examineState:this.examine_state_select,
          rptLevel:this.rpt_level_select,
        }

      };
      ApiService.HeartRecordList(params).then(res => {
					this.loading = false;
					if (res.code == 0) {
						this.listData = res.data.pageList;
						this.page_total = res.data.itemTotal;
					} else if (res.code == 204) {
            pub.refresh(this.initData);
          } else {
            pub.analysisReturnCode(res);
          }
				}).catch(error => {
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					this.loading = false;
					console.log("记录列表报错信息：", error);
				});
    },
    //搜索
    searchHandle() {
      this.current_page = 1;
      this.initData();
    },
    // 下载报告
    downloadReportHandle(val){
      let _this = this;
      let params = {
        page:{
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          itemID:val.heartId
        }
      };
      ApiService.HeartRecordReport(params).then(res=>{
        if(res.code == 0){
         _this.consReportUrl = res.data.pageList[0].rpt_all_url;
         pub.fileLinkToStreamDownload(_this.consReportUrl, '报告_' + val.csrName + val.csrMobile, 'pdf');
        } else if (res.code == 204) {
          pub.refresh(_this.downloadReportHandle(val));
        } else {
          pub.analysisReturnCode(res);
        }
      }).catch(error => {
        this.loading = false;
          if(error == "Error: Request failed with status code 400"){
            this.$message({
                showClose: true,
                message: error,
                type: 'error',
                duration:2000
            });
          }
          console.log("记录列表报错信息：",error);
      });
    },
    // 缩略图
    showPicHandle(item) {
      let fileName = new Array();
      fileName.push(item.fileName)
      let that = this;
      that.file_size = Number(item.fileLength) * 1024;
      let params = {
        page:{
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms:fileName
      };
      ApiService.getHeartPicUrl(params).then(res => {
        if (res.code == 0) {
          that.file_name = res.data[0];
          that.showPreviewDialog = true;
          that.$nextTick(()=>{
              that.$refs.canvasView.sendMessage();
          });
        } else if (res.code == 204) {
          pub.refresh(this.showPicHandle(item));
        } else {
          pub.analysisReturnCode(res);
        }
      })
    },
    // canvas子组件返回上，下一页点击状态及当前第几张canvas （从0开始）
    changeCurPage(item) {
      if (item.file_status == 404 || item.file_status == 'error') {
        this.showPreviewDialog = false;
        this.$message({
            showClose: true,
            message: "文件不存在,请重新上传",
            type: 'error',
            duration: 2000
        });
      } else {
        this.showPreviewDialog = true;
      }
    },
    //操作列表
    showOperationDia(item){
      this.$refs.operation_record.showOperationListDia(item);
    },
    // 审核状态
    getExamineStateList(){
      ApiService.GetExamineStateList({}).then(res => {
					if (res.code == 0) {
						this.examine_state_options = this.examine_state_options.concat(res.data.pageList);
					} else if (res.code == 204) {
            pub.refresh(this.getExamineStateList);
          } else {
            pub.analysisReturnCode(res);
          }
				}).catch(error => {
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					console.log("审核状态报错信息：", error);
				});
    },

    // 订单状态
    getCurStateList(){
      ApiService.GetCurStateList({}).then(res => {
					if (res.code == 0) {
						this.cur_state_options = this.cur_state_options.concat(res.data.pageList);
					} else if (res.code == 204) {
            pub.refresh(this.getExamineStateList);
          } else {
            pub.analysisReturnCode(res);
          }
				}).catch(error => {
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					console.log("审核状态报错信息：", error);
				});
    },
    // 获取选中的内容
    selectHandle(val){
      let templist = [];
      for (let i = 0; i < val.length; i++) {
        templist[i] = {
          ord_id: val[i].heartRecvId,
          exam_code: val[i].examCode,
          csr_name:val[i].csrName,
          rpt_all_url:val[i].rptAllUrl,
        };
      }
      this.batch_list = templist;
    },
    // 获取下载地址
    getDownloadUrl(){
      if(this.batch_list.length < 1){
        this.$message({
            showClose: true,
            message: '请选择要下载的记录',
            type: 'warning',
            duration: 2000
          });
        return;
      }

      this.download_dis = true;
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        jobid:this.uuid(),
        filelist:this.batch_list,
      };
      ApiService.HeartRecordDownload(params).then(res => {
          this.download_dis = false;
          loading.close();
          if(res.code == 200){
            let date = new Date();
            let day = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            pub.fileLinkToStreamDownload(res.data, '数据记录下载'+day, 'zip');
          } else if (res.code == 400 || res.code == 204) {
            pub.refresh(this.getDownloadUrl);
          } else {
            pub.analysisReturnCode(res);
          }
				}).catch(error => {
          this.download_dis = false;
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					console.log("批量下载报错信息：", error);
				});
    },
    uuid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        let uuid = s.join("");
        return uuid;
    },


  },
}
</script>

<style scoped lang="scss">
  .filter-content,.dia-load {
    text-align: left;
  }
  >>>.line-dialog .el-dialog__body{
      padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/RecordList.vue